 // auditType 为显示的状态列表枚举
 // submitType: 'conflict'为车型不一致,'tradeMiss'为交易缺失，用与判断调用不同接口
 //defaultType  车型不一致需要特殊需求  加个字段  方便多场景判断显示
export let props = ['dialog', 'row', 'auditType','submitType','stationCode','defaultType'];
export let model = {
  // 临时表单
  formModel: {
    // 确认状态
    auditType: 0,
    // 审核意见
    auditMsg: ''
  },
};

export let computed = {
  visible: {
    get() {
      return this.dialog;
    },
    set(v) {
      this.$emit('update:dialog', v);
    }
  }
};
